module.exports = __webpack_public_path__ + "img/mairipora.777a084c.png";